import { DestroyRef, Directive, ElementRef, Input, NgZone, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GridsterConfig } from 'angular-gridster2';
import { Subject, debounceTime } from 'rxjs';

/**
 * Observa o tamanho REAL do container do <gridster> e chama
 * options.api.resize() quando ele muda (animação do nz-sider,
 * troca de aba, split, janela...).
 *
 * Substitui os setTimeout(0/100/550ms) + detectChanges() que o
 * main-dashboard usava para "adivinhar" o fim das animações.
 */
@Directive({
    selector: '[gridsterAutoResize]',
    standalone: false,
})
export class GridsterAutoResizeDirective implements OnInit, OnDestroy {

    @Input('gridsterAutoResize') options: GridsterConfig | null | undefined;

    private observer?: ResizeObserver;
    private readonly resize$ = new Subject<void>();

    constructor(
        private el: ElementRef<HTMLElement>,
        private zone: NgZone,
        private destroyRef: DestroyRef,
    ) { }

    ngOnInit(): void {
        this.zone.runOutsideAngular(() => {
            this.resize$
                .pipe(debounceTime(50), takeUntilDestroyed(this.destroyRef))
                .subscribe(() => {
                    this.options?.api?.optionsChanged?.();
                    this.options?.api?.resize?.();
                });

            if (typeof ResizeObserver !== 'undefined') {
                this.observer = new ResizeObserver(() => this.resize$.next());
                this.observer.observe(this.el.nativeElement);
            }
        });
    }

    ngOnDestroy(): void {
        this.observer?.disconnect();
    }
}
